export default __webpack_public_path__ + "static/media/section3_image.35613c47.png";